import axios from 'axios';
import Errors from './Errors';

export default {
  data() {
    return {
      baseUrl: '',
      userId: null,
    };
  },
  async getFromCategory(key) {
    try {
      const { data } = await axios.get(`${this.baseUrl}Parameters/Category/${key}`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getFromCategoryForDate(key, date) {
    try {
      const { data } = await axios.get(`${this.baseUrl}Parameters/Category/${key}/Date/${date}`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getParameter(key) {
    try {
      const { data } = await axios.get(`${this.baseUrl}Parameters/Key/${key}`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getFromId(id) {
    try {
      const { data } = await axios.get(`${this.baseUrl}Parameters/${id}`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async get() {
    try {
      const { data } = await axios.get(`${this.baseUrl}Parameters`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getParameterForAdministration(id) {
    try {
      const { data } = await axios.get(`${this.baseUrl}Parameters/Administration/${id}`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getForAdministration() {
    try {
      const { data } = await axios.get(`${this.baseUrl}Parameters/Administration`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async put(id, parameter) {
    try {
      const json = JSON.stringify(parameter);
      const data = await axios.put(`${this.baseUrl}Parameters/${id}`, json, {
        headers: {
          'Content-Type': 'application/json',
          'User-Id': this.userId,
        },
      });
      return [null, data.data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async putMessage(id, parameter) {
    try {
      const json = JSON.stringify(parameter);
      const data = await axios.put(`${this.baseUrl}Parameters/Message/${id}`, json, {
        headers: {
          'Content-Type': 'application/json',
          'User-Id': this.userId,
        },
      });
      return [null, data.data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async deleteParameters(parameters) {
    try {
      parameters.forEach(async (element) => {
        this.deleteParameter(element.id);
      });
      return true;
    } catch (error) {
      Errors.onError(error);
      return false;
    }
  },
  async deleteParameter(id) {
    try {
      await axios({
        method: 'DELETE',
        url: `${this.baseUrl}Parameters/${id}`,
        headers: {
          'User-Id': this.userId,
        },
      });
      return true;
    } catch (error) {
      Errors.onWarn(error);
      return false;
    }
  },
};
